import {
    FlexColumnWrapper,
    UserDetails,
    ReusableInput,
    InputErrorMessageLabel,
    SectionWrapper,
    ModalBuilder,
    MComponent,
} from '@toluna-dashboarding/usermanagement';
import ExternalUserTypeCreate from '../external-components/ExternalUserTypeCreate';
import { defaultTheme } from '../../../../../utils/defaultTheme';

const createUserModalSpecs = new ModalBuilder('Create User');

const leftSide = new MComponent(FlexColumnWrapper, 'create-user-left-side-wrapper');
const rightSide = new MComponent(FlexColumnWrapper, 'create-user-right-side-wrapper');
createUserModalSpecs.addChildren([leftSide, rightSide]);

const userDetails = new MComponent(UserDetails, 'create-user-user-details').setProps({
    overwriteStyleObject: {
        width: '300px',
        height: '365px',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 6px',
        backgroundColor: defaultTheme.white.ff,
        color: defaultTheme.blue[950],
        opacity: 1,
        fontSize: '15px',
        borderRadius: '3px',
        margin: '30px 30px 0 0',
    },
});

leftSide.addChild(userDetails);
const inputs = [
    {
        id: 'create-user-first-name-input',
        input: {
            label: 'First name',
            id: 'first_name_input',
            width: '250px',
        },
        error: {
            label: 'Please enter the first name',
        },
    },
    {
        id: 'create-user-last-name-input',
        input: {
            label: 'Last name',
            id: 'last_name_input',
            width: '250px',
        },
        error: {
            label: 'Please enter the last name',
        },
    },
    {
        id: 'create-user-email-input',
        input: {
            label: 'E-mail',
            id: 'email_input',
            input_type: 'email',
            useFor: 'Email',
            width: '250px',
        },
        error: {
            label: 'Please enter the email',
        },
    },
];

inputs.forEach(({ id, input, error }) => {
    const inputComponent = new MComponent(ReusableInput, id).setProps({ ...input });
    const errorComponent = new MComponent(InputErrorMessageLabel, id + '-error').setProps({ ...error });

    inputComponent.addChild(errorComponent);
    userDetails.addChild(inputComponent);
});

rightSide.addChild(
    new MComponent(SectionWrapper, 'create-user-section-wrapper').setProps({
        title: 'User Type',
        overwriteStyleObject: {
            width: '650px',
            height: '365px',
            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 6px',
            backgroundColor: defaultTheme.white.ff,
            color: defaultTheme.blue[950],
            fontSize: '15px',
            opacity: 1,
            borderRadius: '3px',
            marginTop: '30px',
        },
    })
);

createUserModalSpecs
    .findChildById('create-user-section-wrapper')
    .addChild(new MComponent(ExternalUserTypeCreate, 'external-create-user-type'));

export const createUserConfig = createUserModalSpecs;
